export default {"src":"/_next/static/media/advisor.70281774.svg","height":697,"width":759,"blurWidth":0,"blurHeight":0};